<template>
  <div class="header">
    <logo-in-header class="pull-left"></logo-in-header>

    <div class="menu-phone pull-right">
      <div class="fold-navigation" data-toggle="dropdown" role="button" aria-label="button" aria-haspopup="true" aria-expanded="false">
        <img src="/static/img/home/h5_header_btn.png" alt="" />
      </div>
      <ul class="dropdown-menu">
        <li class="menu-list">
          <router-link to="/">{{ $t('index') }}</router-link>
        </li>
        <li class="menu-list nickname-li">
          <router-link to="/dashboard" class="nickname">
            {{ nickName }}
          </router-link>
        </li>
        <li class="menu-list">
          <router-link to="/settings">{{ $t('settings') }}</router-link>
        </li>
        <li class="menu-list">
          <router-link to="/affiliate">{{ $t('invitationRecords') }}</router-link>
        </li>
        <li class="menu-list">
          <router-link to="/recharge">{{ $t('topUpRecords') }}</router-link>
        </li>
        <li class="menu-list" v-if="showCommission">
          <router-link to="/commission">{{ $t('affiliate') }}</router-link>
        </li>
        <li class="menu-list">
          <router-link to="/device-management">{{ $t('device_manage') }}</router-link>
        </li>
        <li>
          <a href="javascript:void(0)" @click="signOut">
            {{$t('signOut')}}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import LogoInHeader from '../../logoInHeader/LogoInHeader.vue'
  import locales from './lang'
  import { mapState } from 'vuex'

  export default{
    name: 'user-center-header-m',
    components: {LogoInHeader},
    locales,
    computed: {
      showCommission() {
        return this.$store.state.commission.commissionApplyStatus === 'complete'
      },
      backendLink() {
        return this.$http.options.root + '/transitToAdmin/' + window.localStorage.getItem('token')
      },
      langIsZh() {
        return this.$store.state.currentLang === 'zh'
      },
      ...mapState({
        user: state => state.user,
        nickName: state => state.user['nickname']
      })
    },
    created: function () {
      this.$store.commit('getToken')
      this.$store.commit('isSpecialHeader', true)
    },
    destroyed() {
      this.$store.commit('isSpecialHeader', false)
    },
    methods: {
      signOut: function () {
        this.$store.dispatch('clearUserInfo')
        this.$router.replace('/')
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";
  @import "../../../assets/scss/mixins/button";
  @import "../../../assets/scss/mixins/gradient";

  * {
    padding: 0;
    margin: 0;
  }

  .navbar-nav .open .dropdown-menu {
    position: absolute;
  }

  .nav .open > a,
  .nav > li > a:hover,
  .nav > li > a:focus {
    background: transparent;
  }
  .header {
    width: 100%;
    padding: 0 .24rem;
    background-color: white;
    @media screen and (max-width: 991px) {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .menu-phone {
    height: .6rem;
    line-height: 60px;
    position: relative;
    span {
      background: #333;
    }
    .fold-navigation {
      cursor: pointer;
      img {
        width: 24px;
        height: 20px;
      }
    }

    .dropdown-menu {
      position: absolute;
      top: .5rem;
      background: #FFF;
      box-shadow: 0 6px .24rem 0 rgba(0,0,0,0.06);
      border-radius: 8px;
      padding: 0 .1rem;
      text-align: center;
      li a {
        line-height: .6rem;
        font-size: 16px;
        color: #333333;
        // color: #fff;
        letter-spacing: 0.38px;
        padding: 0;
      }
      li.menu-list {
        border-bottom: 1px solid #EFEFEF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// UserCenterHeaderM.vue?8e666472